export default __webpack_public_path__ + "static/media/1514.9c2e8c5e.png";